import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

export interface ProductFeatureFlags {
  productAllergensEnabled: boolean;
  productNutritionEnabled: boolean;
}

const DEFAULT_FLAGS: ProductFeatureFlags = {
  productAllergensEnabled: false,
  productNutritionEnabled: false,
};

@Injectable({
  providedIn: 'root',
})
export class ProductFeatureFlagsService {
  private cache$: Observable<ProductFeatureFlags> | null = null;

  constructor(private api: ApiService) {}

  getFlags(): Observable<ProductFeatureFlags> {
    if (!this.cache$) {
      this.cache$ = this.fetchFlags().pipe(shareReplay(1));
    }
    return this.cache$;
  }

  refresh(): void {
    this.cache$ = null;
  }

  private fetchFlags(): Observable<ProductFeatureFlags> {
    return this.api.getRequest(ApiUrl.productFeatureFlags).pipe(
      map((res: any) => ({
        productAllergensEnabled: res.response?.data?.productAllergensEnabled === true,
        productNutritionEnabled: res.response?.data?.productNutritionEnabled === true,
      })),
      catchError(() => {
        this.cache$ = null;
        return of({ ...DEFAULT_FLAGS });
      })
    );
  }
}
